document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".use-cases");
  if (!root || root.dataset.bound === "1") return;
  root.dataset.bound = "1";

  const buttons = Array.from(root.querySelectorAll(".use-cases__btn"));
  const panels = Array.from(root.querySelectorAll(".use-cases__panel"));

  function closeAll() {
    buttons.forEach((b) => b.classList.remove("is-active"));
    panels.forEach((p) => {
      p.classList.remove("is-open");
      if (p._hbarRAF) {
        cancelAnimationFrame(p._hbarRAF);
        p._hbarRAF = null;
      }
    });
    delete root.dataset.openBlock;
  }

  function openOnly(id) {
    closeAll();
    const btn = buttons.find((b) => b.dataset.blockId === id);
    const pnl = panels.find((p) => p.dataset.blockId === id);
    if (btn) btn.classList.add("is-active");
    if (pnl) {
      pnl.classList.add("is-open");
      attachScrollbar(pnl);
    }
    root.dataset.openBlock = id;
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.blockId;
      if (root.dataset.openBlock === id) closeAll();
      else openOnly(id);
    });
  });

  root.addEventListener("click", (e) => {
    if (e.target.closest(".use-cases__close")) {
      e.preventDefault();
      e.stopPropagation();
      closeAll();
    }
  });

  const menuOverlay = document.querySelector(".use-cases");
  const footer = document.querySelector(".footer");
  if (menuOverlay && footer) {
    let footerVisible = false;
    const updateMenuState = () => {
      if (footerVisible || window.scrollY < 800) {
        menuOverlay.style.opacity = "0";
        menuOverlay.style.pointerEvents = "none";
      } else {
        menuOverlay.style.opacity = "1";
        menuOverlay.style.pointerEvents = "auto";
      }
    };
    new IntersectionObserver(
      (es) => {
        footerVisible = es.some((e) => e.isIntersecting);
        updateMenuState();
      },
      { threshold: 0.1 }
    ).observe(footer);
    document.addEventListener("scroll", updateMenuState, { passive: true });
    updateMenuState();
  }

  function attachScrollbar(panel) {
    const body = panel.querySelector(".use-cases__panel-body");
    const cards = panel.querySelector(".use-cases__cards");
    if (!body || !cards) return;

    let track = panel.querySelector(":scope > .uc-hscrollbar");
    if (!track) {
      track = document.createElement("div");
      track.className = "uc-hscrollbar";
      track.innerHTML = '<div class="uc-hscrollbar__thumb"></div>';
      panel.appendChild(track);
    }
    const thumb = track.firstElementChild;

    if (!panel._hbarBound) {
      panel._hbarBound = true;

      let dragging = false,
        offsetX = 0;
      track.addEventListener("pointerdown", (e) => {
        const rect = track.getBoundingClientRect();
        if (e.target === thumb) {
          dragging = true;
          offsetX = e.clientX - thumb.getBoundingClientRect().left;
          track.setPointerCapture?.(e.pointerId);
        } else {
          const pos = e.clientX - rect.left - thumb.offsetWidth / 2;
          moveThumb(pos);
        }
      });
      window.addEventListener(
        "pointermove",
        (e) => {
          if (!dragging) return;
          const rect = track.getBoundingClientRect();
          moveThumb(e.clientX - rect.left - offsetX);
        },
        { passive: false }
      );
      window.addEventListener("pointerup", () => (dragging = false));

      window.addEventListener("resize", hardRecalc);
      body.addEventListener("scroll", softSync, { passive: true });
    }

    function dims() {
      const contentWidth = cards.scrollWidth;
      const viewportWidth = body.clientWidth;
      const scrollable = Math.max(0, contentWidth - viewportWidth);
      const trackW = track.getBoundingClientRect().width;
      const thumbW = Math.max(32, (viewportWidth / contentWidth) * trackW);
      return { contentWidth, viewportWidth, scrollable, trackW, thumbW };
    }

    function hardRecalc() {
      const { scrollable, trackW, thumbW } = dims();

      if (scrollable <= 0) {
        track.style.display = "none";
        return;
      }
      track.style.display = "block";

      thumb.style.width = `${thumbW}px`;
      softSync();
    }

    function softSync() {
      const { scrollable, trackW } = dims();
      if (scrollable <= 0) return;

      const thumbW = parseFloat(getComputedStyle(thumb).width) || 32;
      const maxThumbX = Math.max(0, trackW - thumbW);
      const x = (body.scrollLeft / scrollable) * maxThumbX;
      thumb.style.transform = `translateX(${x}px)`;
    }

    function moveThumb(pos) {
      const { scrollable, trackW } = dims();
      if (scrollable <= 0) return;

      const thumbW = parseFloat(getComputedStyle(thumb).width) || 32;
      const maxThumbX = Math.max(0, trackW - thumbW);
      const clamped = Math.max(0, Math.min(pos, maxThumbX));
      body.scrollLeft = (clamped / maxThumbX) * scrollable;
    }

    if (panel._hbarRAF) cancelAnimationFrame(panel._hbarRAF);
    const tick = () => {
      if (!panel.classList.contains("is-open")) return;
      hardRecalc();
      panel._hbarRAF = requestAnimationFrame(tick);
    };
    setTimeout(() => {
      hardRecalc();
      tick();
    }, 0);
  }

  const openPanel = panels.find((p) => p.classList.contains("is-open"));
  if (openPanel) attachScrollbar(openPanel);
});
